import React, {useCallback} from 'react';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import Paper from '@material-ui/core/Paper';
import {makeStyles} from '@material-ui/styles';
import classNames from 'classnames';
import theme from '../../../theme';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import {GRANITE_7} from '../../../styles';
import CloseButton from '../CloseButton';

const useStylesHead = makeStyles({
    startIcon: {
        marginRight: 0,
    }
});
export const sidebarWidth = 300;

interface SidebarHeadProps extends React.HTMLProps<HTMLDivElement> {
    onSidebarChange: (sidebar: MapSidebar) => void;
    prevSidebar?: MapSidebar;
}

export function SidebarHead({
    onSidebarChange,
    children,
    prevSidebar,
    title,
}: SidebarHeadProps
) {
    const classes = useStylesHead();

    const onCloseButtonClick = useCallback(event => {
        onSidebarChange({type: 'hidden'});
        event.stopPropagation();
    }, [onSidebarChange]);

    return <div
        style={{
            height: 58,
            position: 'relative',
            borderBottomColor: GRANITE_7,
            borderBottomWidth: 1,
            borderBottomStyle: 'solid',
            display: 'flex',
            alignItems: 'center',
        }}
    >
        <Typography variant='h6' style={{
            position: 'absolute',
            textAlign: prevSidebar ? 'center' : 'left',
            left: theme.spacing(2),
            right: theme.spacing(2),
        }}>{title}</Typography>

        {prevSidebar && <Button
            color='primary'
            startIcon={<ArrowBackIosIcon style={{width: 14, height: 14}} />}
            classes={{startIcon: classes.startIcon}}
            onClick={() => onSidebarChange(prevSidebar)}
            style={{left: theme.spacing(1), position: 'absolute', fontSize: 14}}
        >
            Back
        </Button>}

        <div style={{
            position: 'absolute',
            right: theme.spacing(2),
            display: 'flex',
            alignItems: 'center'
        }}>
            {children}

            {!prevSidebar && <CloseButton
                style={{boxShadow: undefined}}
                onClick={onCloseButtonClick}
            />}
        </div>
    </div>;
}

export function SidebarBody({children, style, ...restProps}: React.HTMLAttributes<HTMLDivElement>) {
    return <div {...restProps} style={{
        flex: 1,
        overflowY: 'scroll',
        ...style,
    }}>{children}</div>;
}

export type SidebarProps = React.HTMLAttributes<HTMLDivElement>;

const useStyles = makeStyles({
    sidebar: {
        '@media print': {
            display: 'none !important',
        },
    }
});
export function Sidebar({children, style, className}: SidebarProps) {
    const classes = useStyles();
    const sidebarClasses = classNames({
        [classes.sidebar]: true,
        [className || '']: className !== undefined,
    });

    return (<Paper
        className={sidebarClasses}
        style={{
            borderRadius: 0,
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            ...style
        }}>
        {children}
    </Paper>);
}
